import { render, staticRenderFns } from "./Li.vue?vue&type=template&id=2df790d5&scoped=true&"
import script from "./Li.vue?vue&type=script&lang=js&"
export * from "./Li.vue?vue&type=script&lang=js&"
import style0 from "./Li.vue?vue&type=style&index=0&id=2df790d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df790d5",
  null
  
)

export default component.exports